export default __webpack_public_path__ + "static/media/ResourceSinkShop.256.7a8fc085.png";